import ApiService from '../../global/service/api';

export class LoginService extends ApiService {
  postLoginUser = async (data) => this.post({ url: 'token/', body: data });

  postRefreshUser = async (data) => this.post({ url: 'refresh/', body: data });
}

export default new LoginService();
